"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateEffect = void 0;
const react_1 = require("react");
const debugger_effect_1 = require("./debugger-effect");
function useUpdateEffect(effect, deps, withDebugger = false) {
    const effectHook = withDebugger ? debugger_effect_1.useEffectDebugger : react_1.useEffect;
    const mounted = (0, react_1.useRef)(false);
    effectHook(() => {
        if (mounted.current === false) {
            mounted.current = true;
        }
        else {
            return effect();
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [...(deps !== null && deps !== void 0 ? deps : [])]);
}
exports.useUpdateEffect = useUpdateEffect;
//# sourceMappingURL=update-effect.js.map